import {getTodayStartTime, getTomorrowStartTime} from '../getDayStartTime';

export function inRange(date: UnixTimeStamp, from: UnixTimeStamp, to: UnixTimeStamp): boolean {
  return date >= from && date < to;
}

export function inToday(timestamp: UnixTimeStamp): boolean {
  return inRange(timestamp, getTodayStartTime(), getTomorrowStartTime());
}
